const qualifications = [
  "Senior Secondary",
  "Diploma",
  "Undergraduate",
  "Post Graduate",
];

export default qualifications;
